import React, { useState } from 'react';
import AdSpacePhotoCommentsAdminList from './components/AdSpacePhotoCommentsAdminList';
import AdSpacePhotoCommentsAdminAddPhotoCommentPage from './components/AdSpacePhotoCommentsAdminAddPhotoCommentPage';
import { Box, Tabs, Tab } from '@mui/material';


const AdSpacePhotosAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Ad Space Photo Comments" />
        <Tab label="Insert Ad Space Photo Comment" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpacePhotoCommentsAdminList />}
        {tab === 1 && <AdSpacePhotoCommentsAdminAddPhotoCommentPage />}
      </Box>
    </Box>
  );
};

export default AdSpacePhotosAdminPage;